import { createAsyncThunk } from "@reduxjs/toolkit";
//Include Both Helper File with needed methods
import {
  getSalesSummaryCards as getSalesSummaryCardsApi,
  getSalesReferralLinkDetails as getSalesReferralLinkDetailsApi,
  addSalesReferralLinkDetailsForLanguage as addSalesReferralLinkDetailsForLanguageApi,
  getSalesNetworkChart as getSalesNetworkChartApi,
  getSalesRebateDetails as getSalesRebateDetailsApi,
} from "../../helpers/backend_helper";

// Get Sales Summary Cards
export const getSalesSummaryCards = createAsyncThunk(
  "get/SalesSummaryCards",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesSummaryCardsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
// Get Sales Referral Link Details
export const getSalesReferralLinkDetails = createAsyncThunk(
  "get/SalesReferralLinkDetails",
  async (id: number) => {
    try {
      const response = getSalesReferralLinkDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);
// Add Sales Referral Link Details
export const addSalesReferralLinkDetailsForLanguage = createAsyncThunk(
  "get/addSalesReferralLinkDetailsForLanguage",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = addSalesReferralLinkDetailsForLanguageApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Sales Network Chart
export const getSalesNetworkChart = createAsyncThunk(
  "get/SalesNetworkChart",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesNetworkChartApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Rebate Details
export const getSalesRebateDetails = createAsyncThunk(
  "get/SalesRebateDetails",
  async (id: number) => {
    try {
      const response = getSalesRebateDetailsApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// // Post IB Onboarding Personal Info
// export const addIBOnboardingPersonalInfo = createAsyncThunk(
//   "post/IBOnboardingPersonalInfo",
//   async (data: any) => {
//     try {
//       const response = addIBOnboardingPersonalInfoApi(data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Post IB Onboarding Identity Verification
// export const addIBOnboardingIdentityVerify = createAsyncThunk(
//   "post/IBOnboardingIdentityVerify",

//   async ({ id, data }: { id: number; data: FormData }) => {
//     try {
//       const response = await addIBOnboardingIdentityVerifyApi(id, data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Post IB Onboarding Address Verification
// export const addIBOnboardingAddressVerify = createAsyncThunk(
//   "post/IBOnboardingAddressVerify",

//   async ({ id, data }: { id: number; data: FormData }) => {
//     try {
//       const response = await addIBOnboardingAddressVerifyApi(id, data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Country List
// export const getCountryList = createAsyncThunk("get/CountryList", async () => {
//   try {
//     const response = getCountryListApi();
//     return response;
//   } catch (error) {
//     return error;
//   }
// });

// // Get Country List Int2
// export const getCountryListInt2 = createAsyncThunk(
//   "get/CountryListInt2",
//   async () => {
//     try {
//       const response = getCountryListInt2Api();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Address Infos
// export const getUserAddressInfos = createAsyncThunk(
//   "get/AddressList",
//   async () => {
//     try {
//       const response = getUserAddressInfosApi();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Document Type List
// export const getDocumentTypeList = createAsyncThunk(
//   "get/DocumentTypeList",
//   async () => {
//     try {
//       const response = getDocumentTypeListApi();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Partner Clients
// export const getPartnerClients = createAsyncThunk(
//   "get/PartnerClients",
//   async (id: number) => {
//     try {
//       const response = getPartnerClientsApi(id);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Partner Trading Volume
// export const getPartnerTradingVolume = createAsyncThunk(
//   "get/PartnerTradingVolume",
//   async (id: number) => {
//     try {
//       const response = getPartnerTradingVolumeApi(id);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Partner Balance
// export const getPartnerBalance = createAsyncThunk(
//   "get/PartnerBalance",
//   async (id: number) => {
//     try {
//       const response = getPartnerBalanceApi(id);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get PNL Share Contract Info
// export const getPNLShareContractInfo = createAsyncThunk(
//   "get/PNLShareContractInfo",
//   async (id: number) => {
//     try {
//       const response = getPNLShareContractInfoApi(id);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // change Personal Password
// export const changePersonalPassword = createAsyncThunk(
//   "post/changePersonalPassword",
//   async (data: any) => {
//     try {
//       const response = changePersonalPasswordApi(data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Sca Account Info List
// export const getScaAccountInfoList = createAsyncThunk(
//   "get/getScaAccountInfoList",
//   async () => {
//     try {
//       const response = getScaAccountInfoListApi();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Post Withdrawal Info
// export const addWithdrawalInfo = createAsyncThunk(
//   "post/addWithdrawalInfo",
//   async (data: any) => {
//     try {
//       const response = addWithdrawalInfoApi(data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Post Internal Transfer Info
// export const addInternalTransferInfo = createAsyncThunk(
//   "post/addInternalTransferInfo",
//   async (data: any) => {
//     try {
//       const response = addInternalTransferInfoApi(data);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// // Get Deposit Redirect Parameter
// export const getDepositRedirectParameter = createAsyncThunk(
//   "get/DepositRedirectParameter",
//   async () => {
//     try {
//       const response = getDepositRedirectParameterApi();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   },
// );

// export const clearDepositRedirectParameter = createAsyncThunk(
//   "dashboard/clearDepositRedirectParameter",
//   async () => {
//     return {};
//   },
// );
